import React,{useState,useEffect}  from 'react'
import {Database} from "./Firebase/Firebase"
import {Container, Row, Col,Button,Badge,Form } from "react-bootstrap";
import {Link} from "react-router-dom";
import useLocalStorage from "./LocaleStorage/UseLocaleStorage";
import NavBar from "./NavBar";
import Footer from "./Footer";
const Sabot = () => {
    const [articleToSend,setArticleToSend]=useLocalStorage("Article")
    const [articleWomanSabote,setArticleWomanSabote]=useState([]);
    useEffect(()=>{
        ReadDataFromDatabaseWoman();
    },[])

    const ReadDataFromDatabaseWoman = ()=>{
        const articleWoman = Database.database().ref("WomanArticlesSabot")
        articleWoman.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleWomanSabote(list)
             
        })
    }

    return (
        <>
        <NavBar/>
        <h2 className="section__title text-center title__woman">Sabot</h2>
        <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                    <Container>
                    <Row>
                              {articleWomanSabote.map((sabot)=>(      
                                <Col key={sabot.id} lg={4} md={6} sm={6} xs={4} className="featured__product">
                                     <Link onClick={()=>setArticleToSend(sabot)} to={`/Confirmation/:${sabot.id}`} className="Cardhover">
                                <div className="cardF">
                                    <div className="featured__box">
                                        <Badge className="featured__new">Promo</Badge>
                                        <img src={sabot.urlToUse} className="featured__img" alt="Product"/>
                                    </div>
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${(sabot.prix*1.5)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${sabot.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink buttonComanderLinke" to={`/Confirmation/:${sabot.id}`}>
                                            <Button onClick={()=>setArticleToSend(sabot)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                    <Footer/>
        </>
    )
}

export default Sabot
